module.exports = __webpack_public_path__ + "img/cookie.152b634c.svg";